// Lifecycle of the "Link NC Program Now On Machine" action.
export const LINK_STATUS = {
  Idle: 'Idle',
  Linking: 'Linking',
  Linked: 'Linked',
  Error: 'Error',
} as const;
